<div class="checkEmail__body">
  <div *ngIf="pageData?.hasError" class="form-alert" id="formAlertId">
    <idp-form-alert
      (closePopup)="onClosePopUp()"
      [showCloseButton]="true"
      [message]="pageData?.errorMessage"
    ></idp-form-alert>
  </div>
  <idp-login-header [loginHeaderContent]="pageData"></idp-login-header>

  <section
    id="check_email_section"
    class="checkEmail__section--message"
    [innerHTML]="pageData.checkEmailMessage"
  ></section>

  <div class="checkEmail__cta--button">
    <idp-button
      [label]="pageData.nextDisplayView.button_modal"
      [size]="'full-width'"
      (notify)="submit()"
      [customClass]="'checkEmailButton'"
    ></idp-button>
  </div>
</div>
